import { render, staticRenderFns } from "./change-password.form.vue?vue&type=template&id=2d2c5f3c"
import script from "./change-password.form.ts?vue&type=script&lang=ts&external"
export * from "./change-password.form.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports